import { useState } from "react"
import { Card, CardContent } from "@components/common/card"
import { Input } from "@components/common/input"
import { useQuery } from "@tanstack/react-query"
import { FINANCIAL_SERVER_URL, PRICE_LIST_ALL_ENDPOINT } from "@pma/utils/api-routes"
import { parseCookies } from "nookies"
import { ACCESS_TOKEN } from "@pma/utils/constants"
import axios from "axios"
import { useAuth } from "@pma/stores/auth-store"
import { useSearchParams } from "react-router-dom"
import { DictType } from "@pma/types"
import useTranslator from "@pma/hooks/use-translator"
import PmsLoader from "@components/common/loader"
import AddPriceList from "./add-price-list"
import PriceListCard from "./price-lists-card"
import UnauthorizedCard from "@components/layout/unauthorized-card"

export function PriceListCards() {
  const [searchQuery, setSearchQuery] = useState("")

  const { authConfig } = useAuth()
  const [searchParam] = useSearchParams()
  const { translate } = useTranslator()

  const accessToken = parseCookies()[ACCESS_TOKEN]

  const orgId = authConfig?.last_organization_id

  const queryKey = searchParam.get("revalidate")

  const getPriceLists = async () => {
    const response = await axios.post(
      FINANCIAL_SERVER_URL + PRICE_LIST_ALL_ENDPOINT,
      {
        organization_id: orgId,
        show_deleted: false,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      },
    )
    return response.data
  }

  const {
    data: priceLists,
    isLoading,
    refetch,
    error,
    isError,
  } = useQuery({
    queryKey: ["price-lists", orgId, queryKey],
    queryFn: getPriceLists,
  })

  const filteredPriceLists = priceLists?.filter((contractor: DictType) =>
    contractor?.name?.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  const priceListError = error as DictType

  return (
    <Card className='min-h-[80vh] space-y-3 border-none shadow-none'>
      <CardContent className='p-1'>
        {isError ? (
          <div className='flex items-center'>
            <UnauthorizedCard message={priceListError?.response?.data?.message} />
          </div>
        ) : (
          <>
            {isLoading ? (
              <div className=''>
                <PmsLoader />
              </div>
            ) : (
              <>
                <div className='mb-4 flex items-center justify-between'>
                  <div className='flex items-center gap-2'>
                    <Input
                      placeholder={translate("Search price list") + "..."}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className='w-[300px]'
                    />
                  </div>
                  <AddPriceList revalidate={refetch} />
                </div>
                <div className='grid gap-4'>
                  {!priceLists || priceLists?.length < 1 ? (
                    <Card className='col-span-4 w-full'>
                      <CardContent className='flex h-36 w-full items-center justify-center text-center'>
                        {translate("No price lists found")}{" "}
                      </CardContent>{" "}
                    </Card>
                  ) : (
                    filteredPriceLists?.map((priceList: DictType, index: number) => (
                      <PriceListCard
                        key={priceList?.id}
                        priceList={priceList}
                        refetch={refetch}
                        idx={index}
                      />
                    ))
                  )}
                </div>
              </>
            )}
          </>
        )}
      </CardContent>
    </Card>
  )
}
